module.exports = __webpack_public_path__ + "img/viserx-logo.ce951a5f.png";